import { supabase } from '../supabaseClient';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const authService = {
    async signIn(email, password) {
        try {

            if (!supabaseUrl || !supabaseAnonKey) {
                throw new Error('Configuración de Supabase incompleta. Verifica las variables de entorno.');
            }

            const { data, error } = await supabase.auth.signInWithPassword({
                email: email.trim().toLowerCase(),
                password
            });

            if (error) {
                // Create a clean error object to avoid "body stream already read" issues
                throw new Error(error.message || 'Error de autenticación');
            }


            return data;
        } catch (err) {
            // Re-throw with clean message
            throw new Error(err.message || 'Error de autenticación');
        }
    },

    async signUp(email, password, metadata = {}) {
        try {

            const { data, error } = await supabase.auth.signUp({
                email: email.trim().toLowerCase(),
                password,
                options: {
                    data: metadata // Esta metadata será accesible en el trigger vía NEW.raw_user_meta_data
                }
            });

            if (error) {
                throw new Error(error.message || 'Error al registrar');
            }


            return data;
        } catch (err) {
            throw new Error(err.message || 'Error al registrar');
        }
    },

    async signOut() {
        const { error } = await supabase.auth.signOut();
        if (error) throw new Error(error.message || 'Error al cerrar sesión');
    },

    async getSession() {
        const { data: { session }, error } = await supabase.auth.getSession();
        if (error) throw new Error(error.message || 'Error al obtener sesión');
        return session;
    },

    async getUser() {
        const { data: { user }, error } = await supabase.auth.getUser();
        if (error) throw new Error(error.message || 'Error al obtener usuario');
        return user;
    },

    onAuthStateChange(callback) {
        return supabase.auth.onAuthStateChange(callback);
    }
};
